import React, { ChangeEvent, ReactNode } from "react";
import classNames from "classnames";

import "./CustomCheckbox.scss";

interface Props {
  id: string;
  name?: string;
  label?: string | ReactNode;
  checked?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  required?: boolean;
  readOnly?: boolean;
  blue?: boolean;
  className?: string;
}

const CustomCheckbox: React.FC<Props> = ({
  id,
  name,
  label,
  checked,
  onChange,
  disabled,
  required,
  readOnly,
  blue,
  className,
  ...rest
}) => (
  <div
    className={classNames("ws-checkbox", className, {
      "ws-checkbox--blue": blue,
    })}
    {...rest}
  >
    <input
      type="checkbox"
      id={id}
      name={name}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      required={required}
      readOnly={readOnly}
    />
    <label htmlFor={id}>{label && <span>{label}</span>}</label>
  </div>
);

export default CustomCheckbox;
